import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PostupakPage from "@/pages/PostupakPage";
import ONamaPage from "@/pages/ONamaPage";
import PropisiPage from "@/pages/PropisiPage";
import PrijavaPage from "@/pages/PrijavaPage";
import LegalizacijaKucaSplitPage from "@/pages/LegalizacijaKucaSplitPage";
import LegalizacijaDalmacijaPage from "@/pages/LegalizacijaDalmacijaPage";
import CijenaLegalizacijePage from "@/pages/CijenaLegalizacijePage";
import DokumentacijaZaLegalizacijuPage from "@/pages/DokumentacijaZaLegalizacijuPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App bg-background text-ink">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/postupak-legalizacije" element={<PostupakPage />} />
            <Route path="/o-nama" element={<ONamaPage />} />
            <Route path="/zakonski-propisi" element={<PropisiPage />} />
            <Route path="/prijava" element={<PrijavaPage />} />
            <Route path="/legalizacija-kuca" element={<LegalizacijaKucaSplitPage />} />
            <Route path="/legalizacija-dalmacija" element={<LegalizacijaDalmacijaPage />} />
            <Route path="/cijena-legalizacije" element={<CijenaLegalizacijePage />} />
            <Route path="/dokumentacija-za-legalizaciju" element={<DokumentacijaZaLegalizacijuPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
